module.exports = __webpack_public_path__ + "static/media/24UHCHR5.8fd6f847.jpg";